import { Modal, ModalProps } from 'antd';
import React from 'react';
import omit from 'lodash/omit';
import pick from 'lodash/pick';

type WithModalProps = ModalProps & {
  triggerElement: React.ReactNode;
  contentRef?: React.Ref<any>;
  [key: string]: any;
};
const modalPropsKeys = [
  'triggerElement',
  'contentRef',
  'open',
  'onCancel',
  'title',
  'footer',
  'width'
];

const WithModal = (
  WrappedComponent: React.FC<any>
): React.FC<WithModalProps> => {
  const ComponentWithModal: React.FC<WithModalProps> = (props) => {
    const {
      triggerElement: TriggerElement,
      contentRef,
      open,
      onCancel,
      ...rest
    } = pick(props, modalPropsKeys);

    const contentProps = omit(props, modalPropsKeys);

    const [visible, setVisible] = React.useState(open);

    const handleTrigger = () => {
      setVisible(!visible);
    };

    const handleCancel = (e) => {
      setVisible(!visible);
      if (onCancel) {
        onCancel(e);
      }
    };

    React.useEffect(() => {
      setVisible(open);
    }, [open]);

    return (
      <React.Fragment>
        {TriggerElement
          ? React.isValidElement(TriggerElement)
            ? React.cloneElement(TriggerElement, {
                onClick: handleTrigger
              } as any)
            : TriggerElement
          : null}
        <Modal open={visible} onCancel={handleCancel} {...rest}>
          <WrappedComponent ref={contentRef} {...contentProps} />
        </Modal>
      </React.Fragment>
    );
  };

  ComponentWithModal.displayName = `WithModal(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return ComponentWithModal;
};

export default WithModal;
